<template>
  <div class="dt-row">
    <!-- New row -->
    <div class="dt-row-detail" :class="((item.id === expandId) || index % 2 == 0) ? 'active' : null">
      <div class="body-col event-name" style="width: 12%;" block
           @click="setExpandId(item.id); showCollapse = !showCollapse;"
           :class="(item.id != expandId) ? 'collapsed' : null" :aria-controls="accordionId"
           :aria-expanded="(item.id === expandId) ? 'true' : 'false'">
        <div class="client-name">
          <span v-if="viewMode != 'Client'">{{item.clientName}}</span>
        </div>
        <div class="name">
          <Icon name="chevron-right" class="event-icon" v-if="!showCollapse"></Icon>
          <Icon name="chevron-down" class="event-icon" v-if="showCollapse"></Icon>
          <span class="icon-circle">
            <Icon v-if="item.isChangeOrder" name="exclamation-circle"
                  class="row-detail-icon row-detail-icon-exclamation-circle circle-red"></Icon>
          </span>
          <span>{{ item.eventName || eventName }}</span>
        </div>
      </div>
      <!-- <div class="body-col overflow-show" style="width: 7%;">
        <multiselect :disabled="!editable" v-model="item.prefMonth" :options="listOptionPrefMonth" placeholder="Select month" :value="item.prefMonth" class="data-table-row-edit-mode-text" :allow-empty="false"></multiselect>
      </div> -->
      <div class="body-col" style="width: 9%;">
        <!--<input v-model="item.prefDate" :value="item.prefDate || ''" class="data-table-row-edit-mode-text"
               placeholder="12/2017" :readonly="!editable"/>-->
        <the-mask mask="##/##/####"
                  v-model="item.prefDate"
                  :value="item.prefDate || ''"
                  class="data-table-row-edit-mode-text"
                  :masked="isTrue"
                  :readonly="!editable"></the-mask>
      </div>
      <div class="body-col" style="width: 5%;">
        <div class="data-table-icon-circle">
          <Icon v-if="enableIconProjPart" name="exclamation-circle"
                class="row-detail-icon row-detail-icon-exclamation-circle"></Icon>
        </div>
        <input v-model="item.projPart" class="data-table-row-edit-mode-text data-table-row-edit-mode-input-small"
               placeholder="100" :readonly="!editable"/>
      </div>
      <div class="body-col" style="width: 27%;">
        <input v-model="item.fullAddress" class="data-table-row-edit-mode-text" placeholder="Address"
               :readonly="!editable"/>
        <!-- <GmapAutocomplete :readonly="!editable" v-model="item.fullAddress" name="address-input" class="data-table-row-edit-mode-text" placeholder="Address" size="sm"></GmapAutocomplete> -->
      </div>
      <div class="body-col" style="width: 7%;">
        <input v-model="item.eventLocation" class="data-table-row-edit-mode-text" placeholder="Building 3"
               :readonly="!editable"/>
      </div>
      <div class="body-col" style="width: 7%;">
        <span>{{ item.startTime }}</span>
      </div>
      <!-- duration -->
      <div class="body-col" style="width: 5%;">
        <div class="data-table-icon-circle">
          <Icon v-if="enableIconProjPart" name="exclamation-circle"
                class="row-detail-icon row-detail-icon-exclamation-circle"></Icon>
        </div>
        <span>{{ calculateDuration }}</span>
      </div>
      <!-- endTime -->
      <div class="body-col" style="width: 7%;">
        <span class="">{{calculateTimeEnd}}</span>
      </div>
      <div class="body-col" style="width: 4%;">
        <input v-model="item.timeZone" class="data-table-row-edit-mode-text" placeholder="EST" :readonly="!editable"/>
      </div>
      <div class="body-col" style="width: 9%;">
        <div class="data-table-icon-circle">
          <Icon v-if="disableIconContact" name="exclamation-circle"
                class="row-detail-icon row-detail-icon-exclamation-circle"></Icon>
        </div>
        <input v-model="item.contactName" class="data-table-row-edit-mode-text data-table-input-contact-name"
               placeholder="Daniel" :readonly="!editable"/>
      </div>
      <!-- action -->
      <div class="body-col" style="width: 8%;">
        <div>
          <RowStatus :eventStatus="item.status"></RowStatus>
        </div>
      </div>
    </div>
    <!-- ROW DETAIL -->
    <b-collapse :id="accordionId" v-model="showCollapse" accordion="datatable-accordion">
      <div class="dt-row-item-detail">
        <div class="item-detail-header">
          <div class="row">
            <div class="col-sm-2">alerts</div>
            <div class="col-sm-7">event notes</div>
            <div class="col-sm-3">on site contact</div>
          </div>
        </div>
        <div class="item-detail-body">
          <div class="row">
            <div class="col-sm-3">
              <ul>
                <li v-if="item.projPart < 33">Events under 33 participants are flagged with small site message.</li>
                <li v-if="item.projPart >= 200">Your estimated participation is high. Break event into 2 days.</li>
                <li v-if="disableIconContact">Missing email and phone number for on site contact.</li>
              </ul>
            </div>
            <div class="col-sm-6">
              <div class="notes-field">
                <div class="text-label">
                  shipping address
                  <span class="grey-3">(if different than event address)</span>
                </div>
                <div class="text-value">
                  <input v-model="item.shippingAddress" class="data-table-row-edit-mode-text" placeholder="Address"
                         :readonly="!editable"/>
                </div>
              </div>
              <div class="notes-field">
                <div class="text-label">
                  custom event notes
                </div>
                <div class="text-value">
                  <textarea v-model="item.customEventNote" name="custom-notes" class="custom-notes"
                            placeholder="E.g. add ons, extra staff, etc" :readonly="!editable"></textarea>
                </div>
              </div>
              <div class="notes-field">
                <div class="text-label">
                  Additional comments
                </div>
                <div class="text-value">
                  <textarea name="additional-comments" v-model="item.additionalComments" class="additional-comments"
                            placeholder="E.g. instructions from client or change documentation"
                            :readonly="!editable"></textarea>
                </div>
                <div class="add-on-wrapper">
                  <div class="add-on-item">
                    <div class="text">
                      <input type="checkbox" v-model="item.isOnlineScheduler" id="is-online-scheduler"
                             :disabled="true"/>
                      <label for="is-online-scheduler">Toggle</label>
                    </div>
                    <div class="text title" :class="{active: item.isOnlineScheduler}">Online Scheduler</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-3">
              <div class="text-contact">
                <span>{{item.contactName}}</span>
              </div>
              <div class="text-contact grey-3">
                <input v-model="item.email"
                       class="phoneAndEmail"
                       placeholder="E.g. hannah_welch@gmail.com" :readonly="!editable"/>
              </div>
              <div class="text-contact grey-3">
                <!--<input v-model="item.phone"
                       class="phoneAndEmail"
                       placeholder="(123) 123-1234" :readonly="!editable"/>-->
              </div>
              <!-- BUTTON FUNCTION GROUP -->
              <div class="func-group">
                <!-- <div class="last-action">Last submitted by Tyler Smith 5:30 PM</div> -->
              </div>
              <!-- END: BUTTON FUNCTION GROUP -->
            </div>
          </div>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
  import 'vue-awesome/icons/exclamation-circle';
  import 'vue-awesome/icons/arrow-circle-o-right';
  import 'vue-awesome/icons/chevron-right';
  import 'vue-awesome/icons/chevron-down';
  import 'vue-awesome/icons/floppy-o';
  import 'vue-awesome/icons/trash-o';
  import 'vue-awesome/icons/repeat';
  import 'vue-awesome/icons/exchange';
  import 'vue-awesome/icons/angle-right';
  import 'vue-awesome/icons/refresh';
  import Multiselect from 'vue-multiselect';
  import Icon from 'vue-awesome/components/Icon';
  import constants from '../../_consts';
  import moment from 'moment';
  import {mapGetters} from 'vuex';
  import RowStatus from './RowStatus';
  import {TheMask} from '../utils/vue-the-mask';

  export default {
    name: 'dataTableRow',
    components: {
      Icon,
      Multiselect,
      RowStatus,
      TheMask
    },
    props: {
      id: {
        type: Number,
        default: 0
      },
      index: {
        type: Number,
        default: 0
      },
      eventStatus: {
        type: String
      },
      item: {
        type: Object,
        default: null
      },
      viewMode: {
        type: String,
        default: ''
      },
      editable: {
        type: Boolean,
        default: false
      },
      showOnModal: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        showCollapse: false,
        focusedColumn: '',
        listOptionPrefMonth: constants.listOptionPrefMonth,
        isSuggestChanges: false,
        iconNames: constants.iconNames,
        listEventStatus: constants.eventStatus,
        viewModes: constants.dataTableViewModes,
        isTrue: true
      };
    },
    computed: {
      newPrefMonth () {
        let time = moment(this.item.prefDate, 'MM/DD/YYYY');
        let str = time.format('MMM').toUpperCase();
        this.item.newPrefMonth = str;
        return str;
      },
      newPrefDate () {
        let time = moment(this.item.prefDate, 'MM/DD/YYYY');
        let str = time.format('DD') + '/' + time.format('YYYY');
        this.item.newPrefDate = str;
        return str;
      },
      expandId () {
        return this.getExpandId;
      },
      showRelatedEvent () {
        return this.showRelatedEvents;
      },
      ...mapGetters({
        getExpandId: 'GETTERS_GET_EXPAND_ID',
        showRelatedEvents: 'GETTERS_SHOW_RELATED_EVENT'
      }),
      accordionId () {
        return `accordion-${this.item.id}`;
      },
      eventName () {
        if (this.item.eventName === undefined || this.item.eventName === '') {
          this.item.eventName = 'New Event';
        }
        return this.item.eventName;
      },
      calculateDuration () {
        if (this.item.projPart > 0 && this.item.projPart <= 32) {
          this.item.duration = 4;
        }
        if (this.item.projPart > 32 && this.item.projPart < 100) {
          this.item.duration = 4;
        }
        if (this.item.projPart >= 100 && this.item.projPart <= 140) {
          this.item.duration = 5;
        }
        if (this.item.projPart > 140 && this.item.projPart < 170) {
          this.item.duration = 6;
        }
        if (this.item.projPart >= 170 && this.item.projPart < 200) {
          this.item.duration = 7;
        }
        if (this.item.projPart >= 200) {
          this.item.duration = 8;
        }
        if (this.item.duration > 0) {
          return this.item.duration + ' HR';
        }
        return '';
      },
      enableNoteForProjPart () {
        return (this.item.duration === 4 || this.item.duration === 8);
      },
      enableNoteForEventDuration () {
        return (this.item.duration === 4 || this.item.duration === 8);
      },
      calculateTimeEnd () {
        let listStr = this.item.startTime.toString().split(':');
        if (listStr.length > 1) {
          let hour = Number(listStr[0]);
          hour += this.item.duration;
          if (hour > 23 || hour < 12) {
            this.item.endTime = hour % 12 + ':' + listStr[1] + ' AM';
          }
          if (hour > 12 && hour <= 23) {
            this.item.endTime = hour % 12 + ':' + listStr[1] + ' PM';
          }
          if (hour === 12) {
            this.item.endTime = 12 + ':' + listStr[1] + ' PM';
          }
        }
        return this.item.endTime;
      },
      enableIconProjPart () {
        return (this.item.projPart > 0) && (this.item.projPart <= 32 || this.item.projPart >= 200);
      },
      disableIconContact () {
        // return this.item.contactName === '';
        return !(this.item.email !== '' && this.item.phone !== '');
      },
      calculateShippingAddress () {
        if (this.item.shippingAddress === '') {
          this.item.shippingAddress = this.item.fullAddress;
        }
        return this.item.shippingAddress;
      },
      viewRelatedEvent () {
        return this.showRelatedEvents;
      }
    },
    methods: {
      setExpandId (id) {
        this.showCollapse = true;
      }
    }
  };
</script>

<style lang="less">
  @import '../../styles/variables.less';

  .v-select .selected-tag {
    height: 0;
    float: left;
    line-height: 1.7em;
    border-radius: 0;
    border: none;
  }

  .v-select .dropdown-toggle {
    width: 80px;
    margin-top: 6px;
    border-radius: 6px;
    border: solid 1px @blue;
    height: 30px;
  }

  .v-select > .dropdown-menu {
    width: 25px;
  }

  .addressText {
    width: 100%;
    border-radius: 6px;
    border: solid 1px @blue;
    height: 30px;
  }

  .month-dropdown-item {
    height: 176px;
    display: inline-block;
    overflow: scroll;
  }

  .dropdown-item {
    width: 65px;
  }

  .new-event-dropdown-month {
    width: 100%;
    font-size: 17px;
    max-height: 31px;
    padding: 4px 0;
    margin: -6px 0 0 0;
    font-family: @font-family-title;
  }

  .new-event-dropdown-month > button {
    width: 100%;
    font-size: 17px !important;
    max-height: 31px;
    padding: 4px 0;
    margin: -6px 0 0 0;
  }

  .icon-actions {
    width: 25px;
    height: 25px;
    border-radius: 3px;
    margin-left: -3px;
    padding: 5px !important;
  }

  .notes-field {
    .add-on-wrapper {
      float: left;
      height: 33px;
      line-height: 31px;
      .add-on-item {
        .text {
          color: @black-2;
          font-family: "Open Sans", serif;
          font-size: 12px;
          display: inline;
          margin-left: -10px;
        }
        .title {
          margin-left: 8px !important;
          &.active {
            color: #00A4D6;
            font-family: "Open Sans", sans-serif;
            font-size: 12px;
            font-weight: bold;
            line-height: 16px;
          }
        }
        input[type=checkbox] {
          height: 0;
          width: 0;
          visibility: hidden;
        }
        label {
          cursor: pointer;
          text-indent: -9999px;
          width: 32px;
          height: 18px;
          background: #fff;
          border-radius: 15.5px;
          position: relative;
          top: 1.5px;
          left: 5px;
          border: 1.5px solid rgba(0, 0, 0, 0.1);
          margin-bottom: 0;
        }

        label:after {
          content: '';
          position: absolute;
          top: -0.5px;
          left: -0.5px;
          width: 16px;
          height: 16px;
          background: #fff;
          border-radius: 15.5px;
          -webkit-transition: 0.3s;
          transition: 0.3s;
          border: 0.5px solid rgba(0, 0, 0, 0.1);

        }

        input:checked + label {
          background: #00A4D6;
          border: 1.5px solid #00A4D6;
        }

        input:checked + label:after {
          left: calc(100% - 0px);
          transform: translateX(-100%);
          box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.05), 0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 3px 3px 0 rgba(0, 0, 0, 0.05);
        }

        label:active:after {
          width: 15px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// DataTableRow.vue?3e9a093c